import { Offcanvas } from "react-bootstrap";
import PropTypes from "prop-types";
import { useClassFilters } from "./components/ClassFilterProvider";

const CalenderFiltersOffcanvas = ({
	children
}) => {
	const { showFilters: show, toggleFilters } = useClassFilters();
	return (
		<Offcanvas onHide={toggleFilters} show={show}>
			<Offcanvas.Header closeButton>
				<Offcanvas.Title>Event Filters</Offcanvas.Title>
			</Offcanvas.Header>
			<Offcanvas.Body>
				{children}
			</Offcanvas.Body>
		</Offcanvas>
	);
};

CalenderFiltersOffcanvas.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.element),
		PropTypes.element,
		PropTypes.object
	])
};

CalenderFiltersOffcanvas.defaultProps = {
	children: null
};

export default CalenderFiltersOffcanvas;
